import PropTypes from 'prop-types';
import defaultLogo from 'url:../../../../../resource/favicon/android-chrome-384x384.png';
import defaultPayviewLogo from 'url:../../../../../resource/favicon/payview/android-chrome-384x384.png';

/**
 *
 * @param root0
 * @param root0.assets
 * @param root0.className
 * @param root0.logoClassName
 * @returns {JSX} Logo
 */
function Logo({ assets, className, logoClassName }) {
    return (
        <div className={className}>
            <img
                alt=''
                src={assets?.pathLogo ? assets?.pathLogo : defaultLogo}
                className={logoClassName}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = defaultLogo;
                }}
            />
        </div>
    );
}

/**
 *
 * @param root0
 * @param root0.assets
 * @param root0.className
 * @param root0.logoClassName
 * @returns {JSX} LogoCustomPay
 */
function LogoCustomPay({ assets, className, logoClassName }) {
    return (
        <div className={className}>
            <img
                alt=''
                src={assets?.pathLogo ? assets?.pathLogo : defaultPayviewLogo}
                className={logoClassName}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = defaultPayviewLogo;
                }}
            />
        </div>
    );
}
Logo.propTypes = {
    assets: PropTypes.object,
    className: PropTypes.string,
    logoClassName: PropTypes.string
};

LogoCustomPay.propTypes = {
    assets: PropTypes.object,
    className: PropTypes.string,
    logoClassName: PropTypes.string
};

export default Logo;
export { LogoCustomPay };